"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeterministicSeedPhrase = void 0;
// Don't change! We need maintain original determinism since the beginning
exports.DeterministicSeedPhrase = "TestRPC is awesome!";
//# sourceMappingURL=constants.js.map